import React from 'react';
import { motion } from 'framer-motion';
import { fadeUp } from '../utils/motion';
export function FinalCTA() {
  return <section className="py-24 lg:py-32 px-4 sm:px-6 lg:px-8 bg-navy-deep text-center" data-id="element-341" data-mp="3udp26xtznyt6">
      <motion.div {...fadeUp} className="max-w-4xl mx-auto" data-id="element-342" data-mp="c7twtozhd0w5">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-6 leading-tight" data-id="element-343" data-mp="856zx9nycps3">
          Build more capable people. <br className="hidden md:block" data-id="element-344" data-mp="m3wxsrilithi" />
          Stronger institutions. Better leadership.
        </h2>

        <p className="text-lg text-surface-muted/80 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-345" data-mp="h52frrsgd8yg">
          SyNeural’s CJI and NCJI frameworks connect assessment with
          development. Noetivra would make their tasks, findings, and pathways
          accessible through a visual, interactive workspace.
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-346" data-mp="14vpr6n1kugpr">
          <a href="/contact" className="bg-white text-navy font-bold px-8 py-4 rounded-md hover:bg-surface-muted transition-colors duration-150 whitespace-nowrap" data-id="element-347" data-mp="zxeg68zjq05y">
            Contact Us
          </a>
          <a href="/partnerships" className="bg-transparent border border-white/30 text-white font-medium px-8 py-4 rounded-md hover:bg-white/10 transition-colors duration-150 whitespace-nowrap" data-id="element-348" data-mp="2h5u3yugzoufq">
            Start a Partnership Conversation
          </a>
        </div>
      </motion.div>
    </section>;
}